import { apiAMS } from "../helpers/apiHelper";

/**
 * Send request to resend users verification email
 */
export const submitResendVerificationEmail = async (verifyUsername: string) => {
  const url =
    "public/registration/resend-verification-email?username=" + verifyUsername;

  return apiAMS
    .post(url)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Send request to for forgotten username
 */
export const submitForgottenUsername = async (
  email: string,
  recaptcha: string
) => {
  const url =
    "public/registration/forgot-account-username?email=" +
    email +
    "&recaptcha=" +
    recaptcha;

  return apiAMS
    .post(url)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * Send request to for forgotten email
 */
export const submitForgottenEmail = async (
  userName: string,
  firstName: string,
  lastName: string,
  dateOfBirth: string,
  country: string,
  recaptcha: string
) => {
  const data = {
    username: userName,
    firstName: firstName,
    lastName: lastName,
    dateOfBirth: dateOfBirth,
    residenceCountry: country,
    reCaptcha: recaptcha,
  };

  const url = "public/registration/forgot-registered-email";

  return apiAMS
    .post(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
